import { render, staticRenderFns } from "./FinanceDetails.vue?vue&type=template&id=b614e5f4"
import script from "./FinanceDetails.vue?vue&type=script&lang=ts"
export * from "./FinanceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports